/**
 * A phone number as E.164 for a `tel:` link: digits only, a leading `00` read as `+`, and +45
 * when the number has no country code. Display the number as the tenant wrote it; only the link
 * needs this form.
 */
export function toE164(phone: string): string {
  const digits = phone
    .trim()
    .replace(/^00/, '+')
    .replace(/(?!^\+)\D/g, '');
  return digits.startsWith('+') ? digits : `+45${digits}`;
}
